import { render, staticRenderFns } from "./PcModule.vue?vue&type=template&id=4a2de1fa&scoped=true&"
import script from "./PcModule.vue?vue&type=script&lang=js&"
export * from "./PcModule.vue?vue&type=script&lang=js&"
import style0 from "./PcModule.vue?vue&type=style&index=0&id=4a2de1fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2de1fa",
  null
  
)

component.options.__file = "PcModule.vue"
export default component.exports